<div class="container-fluid">
  <h2>Home</h2>
  <div class="row">
    <div class="col-sm-4">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Configuration</h5>
          <p class="card-text">
            Configuration enables the management of Services, Envrionments and
            Tenants.
          </p>
          <a
            href="#"
            class="btn btn-primary"
            routerLink="/configuration/tenants">
            Configuration
          </a>
        </div>
      </div>    
    </div>
    <div class="col-sm-6">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Service Bus</h5>
          <p class="card-text">
            Service Bus allows browsing of Azure Service Bus namespaces,
            as well as management of queue messages.
          </p>
          <a
            href="#"
            class="btn btn-primary"
            routerLink="/service-bus">
            Service Bus
          </a>
        </div>
      </div>    
    </div>    
  </div>
</div>
